
export default {
  name: 'AIcons',
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconName() {
      return `icon-${this.name}`;
    },
  },
};
